export default __webpack_public_path__ + "static/media/icon-email-marketing-last-days.ae798ee3.svg";